
import * as angular from 'angular';
import SearchComponent from './search.component';

/**
 * @ngdoc module
 * @name mw.components.search
 * @description
 *
 * Search
 */
export default angular
    .module('mw.components.search', ['ngMaterial'])
    .component(SearchComponent.config.selector, SearchComponent.config as any);



// WEBPACK FOOTER //
// ./src/lib/components/search/search.module.ts